import { Box, Grid } from "@mui/material";
import {
  ChatCircleDotsIcon,
  MicrosoftTeamsLogoIcon,
  MoneyIcon,
  UserCircleIcon,
  UsersFourIcon
} from "@phosphor-icons/react";
import SMSSentPattern from "assets/images/sms-sent.png";
import SystemUserPattern from "assets/images/system-user.png";
import TotalBalancePattern from "assets/images/total-balance.png";
import TotalMembersPattern from "assets/images/total-members.png";
import TotalTeamsPattern from "assets/images/total-teams.png";
import { Alert, Notification } from "components/UI";
import { useChurchStore } from "features/churches";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCentralStore } from "stores";
import { useGeneralStats, useTopBanks } from "../api";
import {
  FinancesView,
  MembersView,
  MessagesView,
  StatInfoCard,
  SystemAdminsView,
  TeamsView
} from "../components";

export function Dashboard() {
  const setHeaderTitle = useCentralStore(state => state.setHeaderTitle);
  const [dashboardView, setDashboardView] = useState("members");
  const selectedChurch = useChurchStore(state => state.selectedChurch);
  const { t } = useTranslation();

  const generalStatsQuery = useGeneralStats({
    churchId: selectedChurch?.id
  });

  const topBanksQuery = useTopBanks({
    churchId: selectedChurch?.id,
    config: {
      enabled: !!selectedChurch?.id
    }
  });

  useEffect(() => {
    setHeaderTitle("Dashboard");

    return () => setHeaderTitle("");
  }, []);

  return (
    <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
      <Notification />
      <Box sx={{ mb: { xs: 2, sm: 3, md: 4 } }}>
        <Alert message={"dashboard.common.demoMessage"} />
      </Box>
      <Grid container spacing={1} sx={{ mb: { xs: 2, sm: 3, md: 4 } }}>
        <Grid item xs={12} sm={6} md={4} lg={2.4}>
          <StatInfoCard
            title={t("dashboard.dashboard.TotalMembers")}
            stat={generalStatsQuery?.data?.total_active_members ?? 0}
            icon={<UsersFourIcon size={24} />}
            color="#134077"
            background={`url(${TotalMembersPattern}) #13407766`}
            onClick={() => setDashboardView("members")}
            active={dashboardView === "members"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2.4}>
          <StatInfoCard
            title={t("dashboard.dashboard.TotalTeams")}
            stat={generalStatsQuery.data?.total_teams ?? 0}
            icon={<MicrosoftTeamsLogoIcon size={24} />}
            color="#65A6A0"
            background={`url(${TotalTeamsPattern}) #65A6A066`}
            onClick={() => setDashboardView("teams")}
            active={dashboardView === "teams"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2.4}>
          <StatInfoCard
            title={t("dashboard.dashboard.TotalSentMessages")}
            stat={generalStatsQuery?.data?.total_messagesSent ?? 0}
            icon={<ChatCircleDotsIcon size={24} />}
            color="#018ABE"
            background={`url(${SMSSentPattern}) #018ABE66`}
            onClick={() => setDashboardView("messages")}
            active={dashboardView === "messages"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2.4}>
          <StatInfoCard
            title={t("dashboard.dashboard.TotalBalance")}
            stat={topBanksQuery?.data?.total_balance ?? 0}
            icon={<MoneyIcon size={24} />}
            color="#7FA457"
            background={`url(${TotalBalancePattern}) #7FA45766`}
            onClick={() => setDashboardView("finances")}
            active={dashboardView === "finances"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2.4}>
          <StatInfoCard
            title={t("dashboard.dashboard.SystemUsers")}
            stat={generalStatsQuery?.data?.total_users ?? 0}
            icon={<UserCircleIcon size={24} />}
            color="#E39337"
            background={`url(${SystemUserPattern}) #E3933766`}
            onClick={() => setDashboardView("systemAdmins")}
            active={dashboardView === "systemAdmins"}
          />
        </Grid>
      </Grid>
      {dashboardView === "members" && <MembersView />}
      {dashboardView === "teams" && <TeamsView />}
      {dashboardView === "messages" && <MessagesView />}
      {dashboardView === "systemAdmins" && <SystemAdminsView />}
      {dashboardView === "finances" && <FinancesView />}
    </Box>
  );
}
